import { type OutcomeHueName, outcomeHueFromTitle } from '@/lib/chart/outcome-hue';

export function winnerHueFromMint(mint: string): OutcomeHueName {
  return outcomeHueFromTitle(mint, undefined, 'hash');
}
